import type { EPDDefinitionModel, EstimatedServiceLifeModel } from 'types/epd-definition/EPDDefinitionModel';

/** The one backend property that saves the whole Estimated service life object ({ years, description }). */
export const ESTIMATED_SERVICE_LIFE_PROPERTY = 'estimatedServiceLife';

/**
 * The estimated service life has a stored value when the years are set.
 * Zero is a value, so it counts; only null and undefined (no value) mean "not set".
 */
export const hasEstimatedServiceLifeYears = (esl: Pick<EstimatedServiceLifeModel, 'years'> | null | undefined): boolean =>
  esl?.years !== null && esl?.years !== undefined;

/**
 * The years and the description of Estimated service life are shown for a Furniture c-PCR once the years have a value.
 * Each surface decides "Furniture" itself and passes the result in.
 */
export const shouldShowEstimatedServiceLife = (
  isFurniture: boolean,
  esl: Pick<EstimatedServiceLifeModel, 'years'> | null | undefined
): boolean => isFurniture && hasEstimatedServiceLifeYears(esl);

/**
 * Mirrors the backend save of the Estimated service life on the cached definition: the sent object replaces
 * the stored one, with the description null when the years are null. The input is never mutated.
 */
export const applyEstimatedServiceLifeChange = (
  model: EPDDefinitionModel,
  newValue: { years: number | null; description: string | null }
): EPDDefinitionModel => ({
  ...model,
  estimatedServiceLife: {
    years: newValue.years,
    description: newValue.years === null ? null : newValue.description,
  },
});
